import MainLayout from "@/layout/MainLayout.vue";
export default [
  {
    path: "/schoolList",
    component: MainLayout,
    name: "schoolList",
    redirect: "/set/school",
    meta: {
      title: "学校管理",
      icon: "alert",
    },
    // hidden: true,
    hideChildrenInMenu: true,
    children: [
      {
        path: "/set/school",
        name: "school",
        component: () => import("@/views/Set/School"),
        meta: {
          title: "学校管理",
        },
      },
    ],
  },
  {
    path: "/equipment",
    component: MainLayout,
    name: "equipment",
    redirect: "/equipment/machineList",
    meta: {
      title: "设备管理",
      icon: "laptop",
    },
    // hidden: true,
    hideChildrenInMenu: true,
    children: [
      {
        path: "/equipment/machineList",
        name: "machineList",
        component: () => import("@/views/Equipment/Machine"),
        meta: {
          title: "考勤门禁机",
        },
      },
      {
        path: "/equipment/machineList/personList",
        name: "personList",
        hidden: true,
        component: () => import("@/views/Equipment/Machine/personList.vue"),
        meta: {
          title: "查看员工",
        },
      },
    ],
  },
];
